import React from 'react';
import PropTypes from 'prop-types';

import { colors } from '../../../common/styles/style-constants';

const DoctorFemale = ({ color }) => (
  <svg
    width="20"
    height="24"
    viewBox="0 0 66 83"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M48.463 24.23h.098l.958.177c-.013.757-.067 1.5-.174 2.23-.302 4-1.32 7.688-2.86 10.78-2.808 5.626-7.354 9.28-12.48 9.28-7.82 0-14.284-8.496-15.298-19.515 0 0 6.175-1.022 9.86-2.48 0 0 6.683-2.23 14.842-8.106l.122-.087s.146.21.354.567c.707 1.214 2.225 4.832-.645 6.487l5.223.667zm-9.12 30.23L34 63.145l-5.344-8.685c-3.884-.88-6.885-2.692-8.095-4.93 3.135.272 5.79.848 6.477 1.975l-2.943-6.567c2.82 2.816 6.23 4.467 9.905 4.467 3.59 0 6.928-1.574 9.71-4.272l-2.053 4.272c.688-1.133 3.272-1.438 6.308-1.362-.483 2.907-3.904 5.348-8.62 6.417zm22.942-4.93c-7.91-4.35-9.705-19.956-9.705-19.956C53.964-.656 34.014.924 34.014.924c-.03 0-19.98-1.58-18.597 28.65 0 0-1.796 15.605-9.706 19.955 0 0 2.13-.147 4.978-.198-2.447 1.093-3.314 2.626-4.977 7.42C2.688 65.477.82 79.126.82 79.126c-.246 1.637.898 2.964 2.562 2.964h59.172c1.656 0 2.87-1.334 2.69-2.975 0 0-1.105-13.236-4.583-22.362-1.643-4.31-2.568-7.53-5.816-8.35 3.963.444 7.44 1.126 7.44 1.126z"
        fill={color}
      />
      <path
        d="M48.586 62.503v2.667h2.77v-2.667H54v-2.76h-2.643V57.09h-2.77v2.653h-2.643v2.76h2.642z"
        fill="#FFF"
      />
    </g>
  </svg>
);

DoctorFemale.defaultProps = {
  color: colors.blue,
};

DoctorFemale.propTypes = {
  color: PropTypes.string,
};

export default DoctorFemale;
